export const coverageTypeDropdown = () => [
    { id: 1, description: 'Individual', value: 'Individual' },
    { id: 2, description: 'Individual Plus Dependent', value: 'IndividualPlusDependent' },
    { id: 3, description: 'Couple', value: 'Couple'},
    { id: 4, description: 'Family', value: 'Family'},
];